import { Command } from 'common/Prose/Commands'
import { NodeSelection } from 'prosemirror-state'
import { isInTable } from 'prosemirror-tables'
import { deleteSelectionWithTable } from './table/deleteSelectionWithTable'

export const preventTableSelectionDelete: Command = (state, dispatch) => {
  // Prevent it from handling non-table stuff
  if (!isInTable(state)) return false
  // Prevent it from handling empty selections
  if (state.selection.from === state.selection.to) return false
  // Prevent it from handling selections confined to a single node
  if (state.doc.nodeAt(state.selection.from) === state.doc.nodeAt(state.selection.to)) return false
  // Prevent it from handling node selections
  if (state.selection instanceof NodeSelection) return false
  return deleteSelectionWithTable(state, dispatch)
}
